/**
 * Fetal Biometry Percentile Database
 * 
 * Based on INTERGROWTH-21st and Hadlock standards
 * Used by 2000+ gynecologists worldwide
 * 
 * References:
 * - INTERGROWTH-21st Project (Oxford University)
 * - Hadlock FP et al. Radiology 1991
 * - Sonek et al. (Nasal Bone)
 */

// INTERGROWTH-21st BPD (Biparietal Diameter) - mm
export const BPD_PERCENTILES = {
  14: { p3: 26.1, p10: 27.1, p50: 28.9, p90: 30.8, p97: 31.4 },
  15: { p3: 27.9, p10: 28.9, p50: 30.8, p90: 32.6, p97: 33.1 },
  16: { p3: 29.9, p10: 31.8, p50: 33.7, p90: 35.7, p97: 37.6 },
  17: { p3: 32.7, p10: 34.8, p50: 36.8, p90: 38.8, p97: 40.8 },
  18: { p3: 35.6, p10: 37.8, p50: 39.9, p90: 42.0, p97: 44.1 },
  19: { p3: 38.6, p10: 40.8, p50: 43.0, p90: 45.2, p97: 47.4 },
  20: { p3: 41.6, p10: 43.9, p50: 46.1, p90: 48.4, p97: 50.7 },
  21: { p3: 44.5, p10: 46.9, p50: 49.3, p90: 51.7, p97: 54.1 },
  22: { p3: 47.5, p10: 50.0, p50: 52.5, p90: 55.0, p97: 57.4 },
  23: { p3: 50.5, p10: 53.0, p50: 55.6, p90: 58.2, p97: 60.7 },
  24: { p3: 53.4, p10: 56.0, p50: 58.6, p90: 61.2, p97: 63.8 },
  25: { p3: 56.2, p10: 58.8, p50: 61.5, p90: 64.1, p97: 66.8 },
  26: { p3: 58.9, p10: 61.6, p50: 64.3, p90: 66.9, p97: 69.6 },
  27: { p3: 61.5, p10: 64.2, p50: 66.9, p90: 69.6, p97: 72.3 },
  28: { p3: 64.0, p10: 66.7, p50: 69.5, p90: 72.2, p97: 74.9 },
  29: { p3: 66.3, p10: 69.1, p50: 71.9, p90: 74.7, p97: 77.4 },
  30: { p3: 68.5, p10: 71.3, p50: 74.2, p90: 77.0, p97: 79.8 },
  31: { p3: 70.5, p10: 73.4, p50: 76.3, p90: 79.2, p97: 82.1 },
  32: { p3: 72.4, p10: 75.4, p50: 78.3, p90: 81.3, p97: 84.2 },
  33: { p3: 74.1, p10: 77.1, p50: 80.2, p90: 83.2, p97: 86.2 },
  34: { p3: 75.6, p10: 78.7, p50: 81.8, p90: 85.0, p97: 88.1 },
  35: { p3: 76.9, p10: 80.1, p50: 83.3, p90: 86.6, p97: 89.8 },
  36: { p3: 78.0, p10: 81.3, p50: 84.7, p90: 88.0, p97: 91.3 },
  37: { p3: 78.9, p10: 82.4, p50: 85.8, p90: 89.3, p97: 92.7 },
  38: { p3: 79.6, p10: 83.2, p50: 86.8, p90: 90.4, p97: 94.0 },
  39: { p3: 80.1, p10: 83.8, p50: 87.6, p90: 91.4, p97: 95.1 },
  40: { p3: 80.4, p10: 84.3, p50: 88.2, p90: 92.2, p97: 96.1 }
};

// INTERGROWTH-21st HC (Head Circumference) - mm
export const HC_PERCENTILES = {
  14: { p3: 89.0, p10: 93.0, p50: 101.0, p90: 109.0, p97: 113.0 },
  15: { p3: 101.0, p10: 105.0, p50: 113.0, p90: 121.0, p97: 125.0 },
  16: { p3: 113.0, p10: 118.0, p50: 126.0, p90: 135.0, p97: 140.0 },
  17: { p3: 126.0, p10: 131.0, p50: 140.0, p90: 149.0, p97: 154.0 },
  18: { p3: 138.0, p10: 144.0, p50: 154.0, p90: 164.0, p97: 170.0 },
  19: { p3: 151.0, p10: 157.0, p50: 168.0, p90: 179.0, p97: 185.0 },
  20: { p3: 164.0, p10: 170.0, p50: 181.0, p90: 193.0, p97: 199.0 },
  21: { p3: 176.0, p10: 183.0, p50: 195.0, p90: 207.0, p97: 214.0 },
  22: { p3: 188.0, p10: 196.0, p50: 208.0, p90: 221.0, p97: 228.0 },
  23: { p3: 200.0, p10: 208.0, p50: 221.0, p90: 234.0, p97: 242.0 },
  24: { p3: 212.0, p10: 220.0, p50: 234.0, p90: 248.0, p97: 256.0 },
  25: { p3: 223.0, p10: 232.0, p50: 246.0, p90: 261.0, p97: 269.0 },
  26: { p3: 234.0, p10: 243.0, p50: 258.0, p90: 273.0, p97: 282.0 },
  27: { p3: 245.0, p10: 254.0, p50: 270.0, p90: 285.0, p97: 294.0 },
  28: { p3: 255.0, p10: 265.0, p50: 281.0, p90: 297.0, p97: 306.0 },
  29: { p3: 265.0, p10: 275.0, p50: 291.0, p90: 308.0, p97: 318.0 },
  30: { p3: 274.0, p10: 284.0, p50: 301.0, p90: 319.0, p97: 329.0 },
  31: { p3: 283.0, p10: 294.0, p50: 311.0, p90: 329.0, p97: 339.0 },
  32: { p3: 291.0, p10: 302.0, p50: 320.0, p90: 338.0, p97: 349.0 },
  33: { p3: 299.0, p10: 310.0, p50: 328.0, p90: 347.0, p97: 358.0 },
  34: { p3: 306.0, p10: 317.0, p50: 336.0, p90: 355.0, p97: 366.0 },
  35: { p3: 312.0, p10: 324.0, p50: 343.0, p90: 362.0, p97: 374.0 },
  36: { p3: 318.0, p10: 330.0, p50: 349.0, p90: 369.0, p97: 381.0 },
  37: { p3: 323.0, p10: 335.0, p50: 355.0, p90: 375.0, p97: 387.0 },
  38: { p3: 327.0, p10: 340.0, p50: 360.0, p90: 380.0, p97: 392.0 },
  39: { p3: 331.0, p10: 344.0, p50: 364.0, p90: 385.0, p97: 397.0 },
  40: { p3: 334.0, p10: 347.0, p50: 368.0, p90: 389.0, p97: 401.0 }
};

// Nasal Bone Length (NBL) - mm (Sonek et al. reference)
export const NBL_PERCENTILES = {
  14: { p5: 1.8, p50: 2.5, p95: 3.2 },
  15: { p5: 2.1, p50: 2.9, p95: 3.7 },
  16: { p5: 2.4, p50: 3.3, p95: 4.2 },
  17: { p5: 2.7, p50: 3.7, p95: 4.7 },
  18: { p5: 2.8, p50: 4.2, p95: 5.6 },
  19: { p5: 3.5, p50: 4.6, p95: 5.7 },
  20: { p5: 3.6, p50: 5.0, p95: 6.4 },
  21: { p5: 3.9, p50: 5.4, p95: 6.9 },
  22: { p5: 4.3, p50: 5.7, p95: 7.1 },
  23: { p5: 4.6, p50: 6.0, p95: 7.4 },
  24: { p5: 4.7, p50: 6.4, p95: 8.1 },
  25: { p5: 5.0, p50: 6.8, p95: 8.6 },
  26: { p5: 5.3, p50: 7.2, p95: 9.1 },
  27: { p5: 5.6, p50: 7.6, p95: 9.6 },
  28: { p5: 5.9, p50: 8.0, p95: 10.1 },
  29: { p5: 6.2, p50: 8.4, p95: 10.6 },
  30: { p5: 6.5, p50: 8.8, p95: 11.1 },
  31: { p5: 6.8, p50: 9.2, p95: 11.6 },
  32: { p5: 7.1, p50: 9.6, p95: 12.1 },
  33: { p5: 7.4, p50: 10.0, p95: 12.6 },
  34: { p5: 7.7, p50: 10.4, p95: 13.1 },
  35: { p5: 8.0, p50: 10.8, p95: 13.6 },
  36: { p5: 8.3, p50: 11.2, p95: 14.1 },
  37: { p5: 8.6, p50: 11.6, p95: 14.6 },
  38: { p5: 8.9, p50: 12.0, p95: 15.1 },
  39: { p5: 9.2, p50: 12.4, p95: 15.6 },
  40: { p5: 9.5, p50: 12.8, p95: 16.1 }
};

// OFD (Occipitofrontal Diameter) - estimated from BPD ratio
export const OFD_PERCENTILES = {
  18: { p5: 45.0, p50: 52.0, p95: 59.0 },
  19: { p5: 48.0, p50: 56.0, p95: 64.0 },
  20: { p5: 52.0, p50: 60.0, p95: 68.0 },
  21: { p5: 56.0, p50: 64.0, p95: 72.0 },
  22: { p5: 60.0, p50: 68.0, p95: 76.0 },
  23: { p5: 63.0, p50: 72.0, p95: 81.0 },
  24: { p5: 67.0, p50: 76.0, p95: 85.0 },
  25: { p5: 70.0, p50: 80.0, p95: 90.0 },
  26: { p5: 74.0, p50: 84.0, p95: 94.0 },
  27: { p5: 77.0, p50: 87.0, p95: 97.0 },
  28: { p5: 80.0, p50: 91.0, p95: 102.0 },
  29: { p5: 83.0, p50: 94.0, p95: 105.0 },
  30: { p5: 86.0, p50: 97.0, p95: 108.0 },
  31: { p5: 88.0, p50: 100.0, p95: 112.0 },
  32: { p5: 91.0, p50: 103.0, p95: 115.0 },
  33: { p5: 93.0, p50: 105.0, p95: 117.0 },
  34: { p5: 95.0, p50: 107.0, p95: 119.0 },
  35: { p5: 97.0, p50: 109.0, p95: 121.0 },
  36: { p5: 98.0, p50: 111.0, p95: 124.0 },
  37: { p5: 99.0, p50: 112.0, p95: 125.0 },
  38: { p5: 100.0, p50: 113.0, p95: 126.0 },
  39: { p5: 101.0, p50: 114.0, p95: 127.0 },
  40: { p5: 102.0, p50: 115.0, p95: 128.0 }
};

// Orbital Diameter (IOD - Interorbital Distance) - mm
export const IOD_PERCENTILES = {
  18: { p5: 10.0, p50: 13.0, p95: 16.0 },
  19: { p5: 11.0, p50: 14.0, p95: 17.0 },
  20: { p5: 12.0, p50: 15.0, p95: 18.0 },
  21: { p5: 13.0, p50: 16.0, p95: 19.0 },
  22: { p5: 14.0, p50: 17.0, p95: 20.0 },
  23: { p5: 15.0, p50: 18.0, p95: 21.0 },
  24: { p5: 16.0, p50: 19.0, p95: 22.0 },
  25: { p5: 17.0, p50: 20.0, p95: 23.0 },
  26: { p5: 18.0, p50: 21.0, p95: 24.0 },
  27: { p5: 19.0, p50: 22.0, p95: 25.0 },
  28: { p5: 20.0, p50: 23.0, p95: 26.0 },
  29: { p5: 21.0, p50: 24.0, p95: 27.0 },
  30: { p5: 22.0, p50: 25.0, p95: 28.0 },
  31: { p5: 23.0, p50: 26.0, p95: 29.0 },
  32: { p5: 24.0, p50: 27.0, p95: 30.0 },
  33: { p5: 24.5, p50: 27.5, p95: 30.5 },
  34: { p5: 25.0, p50: 28.0, p95: 31.0 },
  35: { p5: 25.5, p50: 28.5, p95: 31.5 },
  36: { p5: 26.0, p50: 29.0, p95: 32.0 },
  37: { p5: 26.5, p50: 29.5, p95: 32.5 },
  38: { p5: 27.0, p50: 30.0, p95: 33.0 },
  39: { p5: 27.5, p50: 30.5, p95: 33.5 },
  40: { p5: 28.0, p50: 31.0, p95: 34.0 }
};

// Biocular Diameter (BOD) - mm (outer orbital distance)
export const BOD_PERCENTILES = {
  18: { p5: 30.0, p50: 36.0, p95: 42.0 },
  19: { p5: 32.0, p50: 38.0, p95: 44.0 },
  20: { p5: 34.0, p50: 40.0, p95: 46.0 },
  21: { p5: 36.0, p50: 42.0, p95: 48.0 },
  22: { p5: 38.0, p50: 44.0, p95: 50.0 },
  23: { p5: 40.0, p50: 46.0, p95: 52.0 },
  24: { p5: 42.0, p50: 48.0, p95: 54.0 },
  25: { p5: 44.0, p50: 50.0, p95: 56.0 },
  26: { p5: 46.0, p50: 52.0, p95: 58.0 },
  27: { p5: 48.0, p50: 54.0, p95: 60.0 },
  28: { p5: 50.0, p50: 56.0, p95: 62.0 },
  29: { p5: 51.0, p50: 57.0, p95: 63.0 },
  30: { p5: 52.0, p50: 58.0, p95: 64.0 },
  31: { p5: 53.0, p50: 59.0, p95: 65.0 },
  32: { p5: 54.0, p50: 60.0, p95: 66.0 },
  33: { p5: 55.0, p50: 61.0, p95: 67.0 },
  34: { p5: 56.0, p50: 62.0, p95: 68.0 },
  35: { p5: 57.0, p50: 63.0, p95: 69.0 },
  36: { p5: 58.0, p50: 64.0, p95: 70.0 },
  37: { p5: 59.0, p50: 65.0, p95: 71.0 },
  38: { p5: 60.0, p50: 66.0, p95: 72.0 },
  39: { p5: 61.0, p50: 67.0, p95: 73.0 },
  40: { p5: 62.0, p50: 68.0, p95: 74.0 }
};

// Mandible (Jaw) Length - mm
export const MANDIBLE_PERCENTILES = {
  18: { p5: 12.0, p50: 16.0, p95: 20.0 },
  19: { p5: 13.0, p50: 17.0, p95: 21.0 },
  20: { p5: 14.0, p50: 18.0, p95: 22.0 },
  21: { p5: 15.0, p50: 19.0, p95: 23.0 },
  22: { p5: 16.0, p50: 20.0, p95: 24.0 },
  23: { p5: 17.0, p50: 21.0, p95: 25.0 },
  24: { p5: 18.0, p50: 22.0, p95: 26.0 },
  25: { p5: 19.0, p50: 23.0, p95: 27.0 },
  26: { p5: 20.0, p50: 24.0, p95: 28.0 },
  27: { p5: 21.0, p50: 25.0, p95: 29.0 },
  28: { p5: 22.0, p50: 26.0, p95: 30.0 },
  29: { p5: 23.0, p50: 27.0, p95: 31.0 },
  30: { p5: 24.0, p50: 28.0, p95: 32.0 },
  31: { p5: 25.0, p50: 29.0, p95: 33.0 },
  32: { p5: 26.0, p50: 30.0, p95: 34.0 },
  33: { p5: 27.0, p50: 31.0, p95: 35.0 },
  34: { p5: 28.0, p50: 32.0, p95: 36.0 },
  35: { p5: 29.0, p50: 33.0, p95: 37.0 },
  36: { p5: 30.0, p50: 34.0, p95: 38.0 },
  37: { p5: 31.0, p50: 35.0, p95: 39.0 },
  38: { p5: 32.0, p50: 36.0, p95: 40.0 },
  39: { p5: 33.0, p50: 37.0, p95: 41.0 },
  40: { p5: 34.0, p50: 38.0, p95: 42.0 }
};

// Mapping from Turkish slider names to percentile data
export const MEASUREMENT_TO_PERCENTILE = {
  bpd: { data: BPD_PERCENTILES, name: 'BPD', nameEn: 'Biparietal Diameter' },
  hc: { data: HC_PERCENTILES, name: 'HC', nameEn: 'Head Circumference' },
  burun: { data: NBL_PERCENTILES, name: 'Burun', nameEn: 'Nasal Bone Length' },
  onarka_bas: { data: OFD_PERCENTILES, name: 'Önarka Baş', nameEn: 'Occipitofrontal Diameter' },
  ofd: { data: OFD_PERCENTILES, name: 'OFD', nameEn: 'Occipitofrontal Diameter' },
  goztepe: { data: IOD_PERCENTILES, name: 'Göztepe', nameEn: 'Interorbital Distance' },
  bioc_cap: { data: BOD_PERCENTILES, name: 'BiocÇap', nameEn: 'Biocular Diameter' },
  cene: { data: MANDIBLE_PERCENTILES, name: 'Çene', nameEn: 'Mandible Length' }
};

/**
 * Calculate percentile for a given measurement
 * @param {string} measurementType - Type of measurement (bpd, hc, etc.)
 * @param {number} value - The measured value in mm
 * @param {number} week - Gestational week (14-40)
 * @returns {object} - { percentile, interpretation, color }
 */
export function calculatePercentile(measurementType, value, week) {
  const mapping = MEASUREMENT_TO_PERCENTILE[measurementType];
  if (!mapping) {
    return { percentile: 50, interpretation: 'Bilinmiyor', color: '#6b7280' };
  }

  const weekData = mapping.data[week];
  if (!weekData) {
    return { percentile: 50, interpretation: 'Hafta verisi yok', color: '#6b7280' };
  }

  // Determine which percentile keys exist
  const hasP3 = weekData.p3 !== undefined;
  const p5 = weekData.p5 ?? weekData.p3;
  const p50 = weekData.p50;
  const p95 = weekData.p95 ?? weekData.p97;

  let percentile;
  let interpretation;
  let color;

  if (value <= p5) {
    // Below 5th percentile - linear interpolation from 0 to 5
    percentile = Math.max(0, (value / p5) * 5);
    interpretation = 'Düşük';
    color = '#ef4444'; // red
  } else if (value <= p50) {
    // Between 5th and 50th
    percentile = 5 + ((value - p5) / (p50 - p5)) * 45;
    interpretation = value < (p5 + p50) / 2 ? 'Normalin altı' : 'Normal';
    color = percentile < 25 ? '#f97316' : '#22c55e'; // orange or green
  } else if (value <= p95) {
    // Between 50th and 95th
    percentile = 50 + ((value - p50) / (p95 - p50)) * 45;
    interpretation = value < (p50 + p95) / 2 ? 'Normal' : 'Normalin üstü';
    color = percentile > 75 ? '#f97316' : '#22c55e'; // orange or green
  } else {
    // Above 95th percentile
    percentile = Math.min(100, 95 + ((value - p95) / p95) * 5);
    interpretation = 'Yüksek';
    color = '#ef4444'; // red
  }

  return {
    percentile: Math.round(percentile * 10) / 10,
    interpretation,
    color,
    p5,
    p50,
    p95,
    week
  };
}

/**
 * Get all percentile data for a gestational week
 * @param {number} week - Gestational week
 * @returns {object} - All percentile ranges for the week
 */
export function getWeekPercentiles(week) {
  const result = {};
  
  for (const [key, mapping] of Object.entries(MEASUREMENT_TO_PERCENTILE)) {
    const weekData = mapping.data[week];
    if (weekData) {
      result[key] = {
        name: mapping.name,
        nameEn: mapping.nameEn,
        p5: weekData.p5 ?? weekData.p3,
        p50: weekData.p50,
        p95: weekData.p95 ?? weekData.p97
      };
    }
  }
  
  return result;
}

/**
 * Generate percentile curve data for a measurement across all weeks
 * @param {string} measurementType - Type of measurement
 * @returns {array} - Array of {week, p5, p50, p95} for charting
 */
export function getPercentileCurve(measurementType) {
  const mapping = MEASUREMENT_TO_PERCENTILE[measurementType];
  if (!mapping) return [];

  const curve = [];
  for (let week = 14; week <= 40; week++) {
    const weekData = mapping.data[week];
    if (weekData) {
      curve.push({
        week,
        p5: weekData.p5 ?? weekData.p3,
        p10: weekData.p10,
        p50: weekData.p50,
        p90: weekData.p90,
        p95: weekData.p95 ?? weekData.p97
      });
    }
  }
  
  return curve;
}

export default {
  BPD_PERCENTILES,
  HC_PERCENTILES,
  NBL_PERCENTILES,
  OFD_PERCENTILES,
  IOD_PERCENTILES,
  BOD_PERCENTILES,
  MANDIBLE_PERCENTILES,
  MEASUREMENT_TO_PERCENTILE,
  calculatePercentile,
  getWeekPercentiles,
  getPercentileCurve
};
